import { Grid, IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { NavigationButton } from './NavigationButton';
import { useTools } from '../../../services/general_services';
import {
  Add,
  Close,
  Home,
  NordicWalking,
  People,
  Person,
  Report,
  Settings,
} from '@mui/icons-material';
import { isMobile } from 'react-device-detect';
import { primaryColor, styles } from '../../../assets/styles/styles';
import { PageType, setCurrentPage } from '../../../store/slices/general.slice';
import { BorderLine } from '../BorderLine';
import { setSelectedActivity } from '../../../store/slices/enterprise.slice';

export function SideNavBar({ setShowNav }: { setShowNav: Function }) {
  const { currentPage } = useSelector((state: any) => state.GeneralSlice);

  const { userData } = useSelector((state: any) => state.EnterpriseSlice);

  const { requestList, requestListLoading, requestListError } = useSelector(
    (state: any) => state.EnterpriseRequestSlice
  );

  const { navigate, dispatch } = useTools();

  return (
    <Grid
      container
      item
      xs={12}
      style={styles.navbar}
      alignContent={'flex-start'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Grid
        item
        container
        xs={10}
        sx={{ display: { xs: 'flex', sm: 'none' } }}
        justifyContent={'flex-end'}
      >
        <IconButton
          onClick={() => {
            setShowNav(false);
          }}
        >
          <Close style={{ color: 'white' }} />
        </IconButton>
      </Grid>
      <Grid item container>
        {/* Image of user */}
        <Grid
          item
          container
          xs={12}
          justifyContent={'center'}
          alignItems={'center'}
          style={{
            paddingBottom: 10,
            ...styles.sidePadding,
          }}
          spacing={2}
        >
          {/* Circle Profile Pic */}
          <Grid container item xs={4} justifyContent={'flex-end'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 55,
                height: 55,
                border: '2px solid white',
                borderRadius: 32,
              }}
            >
              <div
                style={{
                  width: 45,
                  height: 45,
                  borderRadius: 25,
                  backgroundImage: `url(${
                    userData.selfieImageUrl
                      ? userData.selfieImageUrl
                      : '/static/avatar.svg'
                  }`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
            </div>
          </Grid>

          {/* Profile Information */}
          <Grid item xs={8} flexDirection={'column'}>
            <Typography
              variant={'h6'}
              style={{ color: 'white', lineHeight: 1.2 }}
            >
              {userData.firstName}
            </Typography>
            <Typography
              variant={'body1'}
              style={{
                color: 'rgba(255,255,255, 0.7)',
                fontFamily: 'Urbanist',
                fontWeight: 200,
                fontSize: 15,
              }}
            >
              Community Administrator
            </Typography>
          </Grid>
        </Grid>

        <BorderLine />
        <Grid item container xs={12} justifyContent={'center'}>
          <Grid
            item
            container
            xs={10}
            sx={{
              paddingBottom: 2,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={'bold'}
              style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}
            >
              MAIN MENU
            </Typography>
          </Grid>
        </Grid>

        {/* Navigation buttons */}
        <Grid item container xs={12}>
          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_DASHBOARD}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/enterprise/dashboard');
              dispatch(setCurrentPage(PageType.ENTERPRISE_DASHBOARD));

              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<Home style={{ color: 'white' }} />}
            hoveredIcon={<Home style={{ color: primaryColor }} />}
            text={'Dashboard'}
          />

          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_USERS}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/enterprise/members');
              dispatch(setCurrentPage(PageType.ENTERPRISE_USERS));
              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<People style={{ color: 'white' }} />}
            hoveredIcon={<People style={{ color: primaryColor }} />}
            text={'Members'}
            notificationContent={
              requestListLoading || requestListError || requestList.length === 0
                ? undefined
                : requestList.length
            }
          />

          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_ACTIVITIES}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/enterprise/activities');
              dispatch(setCurrentPage(PageType.ENTERPRISE_ACTIVITIES));
              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<NordicWalking style={{ color: 'white' }} />}
            hoveredIcon={<NordicWalking style={{ color: primaryColor }} />}
            text={'Activities'}
          />

          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_NEW_ACTIVITY}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/enterprise/activities/new');
              dispatch(setCurrentPage(PageType.ENTERPRISE_NEW_ACTIVITY));
              dispatch(setSelectedActivity(undefined));

              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<Add style={{ color: 'white' }} />}
            hoveredIcon={<Add style={{ color: primaryColor }} />}
            text={'New Activity'}
          />
          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_SETTINGS}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/enterprise/settings');
              dispatch(setCurrentPage(PageType.ENTERPRISE_SETTINGS));
              dispatch(setSelectedActivity(undefined));

              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<Settings style={{ color: 'white' }} />}
            hoveredIcon={<Settings style={{ color: primaryColor }} />}
            text={'Settings'}
          />
          {/* 
          <NavigationButton
            page={currentPage}
            buttonPage={PageType.ENTERPRISE_REPORTS}
            onClick={() => {
              window.scrollTo(0, 0)
navigate('/enterprise/reports');
              dispatch(setCurrentPage(PageType.ENTERPRISE_REPORTS));

              if (isMobile) {
                setShowNav(false);
              }
            }}
            icon={<Report style={{ color: 'white' }} />}
            hoveredIcon={<Report style={{ color: primaryColor }} />}
            text={'Reports'}
          /> */}
        </Grid>
      </Grid>

      <Grid item container xs={12} justifyContent={'center'}>
        <BorderLine />
        <Grid item xs={10}>
          <Typography
            variant="h6"
            fontSize={14}
            style={{ color: 'rgba(255,255,255,0.7)' }}
          >
            @2024 RouteBuddies Limited
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
